export default __webpack_public_path__ + "static/media/beep.955a6b02.mp3";